import { render } from "./DrawingSurface.vue?vue&type=template&id=002e5f90"
import script from "./DrawingSurface.vue?vue&type=script&lang=ts"
export * from "./DrawingSurface.vue?vue&type=script&lang=ts"

import "./DrawingSurface.vue?vue&type=style&index=0&id=002e5f90&lang=scss"
script.render = render

export default script